module.exports = __webpack_public_path__ + "img/sriwijaya.3f440eb8.svg";